import styled, { css } from 'styled-components';
import { device } from 'app/ui-components/breakpoints';
import { VisuallyHidden } from '../../../../ui-components/utils.styles';
import { playFontSize } from '../../../../ui-components/typography/helpers';
import { regularWhite } from '../../../../ui-components/design-tokens';
import { SharedMenuLinkStyle } from '../MenuItem/MenuItem.styles';

export const Navigation = styled.nav`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media ${device.GteSmall} {
        flex-direction: row;
        margin-left: 10px;
        margin-right: 10px;
    }

    @media ${device.GteLarge} {
        margin-left: 0;
        margin-right: 0;
    }
`;

export const LogoLink = styled.a`
    width: 70px;
    margin-bottom: 20px;

    &:focus,
    &:visited {
        outline: 0;
    }

    @media ${device.GteSmall} {
        margin: 0 10px 0 0;
        flex-basis: 70px;
        width: auto;
    }

    @media ${device.GteLarge} {
        margin-right: 40px;
        flex-basis: 75px;
    }
`;

export const LogoText = styled.span`
    ${VisuallyHidden}
`;

export const MenuItems = styled.ul`
    list-style: none;
    margin: 0 0 10px;
    flex-basis: calc(100% - 70px);
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 0;
    ${playFontSize(1.6)}
    color: ${regularWhite};
    display: inline-flex;

    @media ${device.GteSmall} {
        ${playFontSize(1.7)}
        margin: 0;
        justify-content: flex-start;
        flex-wrap: nowrap;
        flex-basis: calc(100% - 80px);
    }

    @media ${device.GteLarge} {
        flex-basis: calc(100% - 85px);
    }
`;

export const SearchToggle = styled.label`
    cursor: pointer;
    ${SharedMenuLinkStyle}
`;

export const SearchListItem = styled.li<{ hiddenXs?: boolean }>`
    flex-grow: 1;
    display: inline-flex;
    justify-content: flex-end;
    margin: 10px 0;
    flex-basis: 100%;

    @media ${device.GteSmall} {
        margin: 0;
        flex-basis: auto;
    }

    ${(props) =>
        props.hiddenXs &&
        css`
            display: none;

            .no-js & {
                display: inline-flex;
            }

            @media ${device.GteSmall} {
                display: inline-flex;
            }
        `}
`;

SearchListItem.displayName = 'SearchListItem';
